import { createSelector } from "reselect"
import { get, map, size } from "lodash"
import { getGrouping, getIsActive, getSelectedMetricType, getSelectedSubView, getAssetName, getViewType, getMetricTypeOptions } from "."
import { getEndDate, getOrderedSecurities, getSelectedGroupName } from "./data"
import { getExcelValue } from "helpers/csv"
import { getTickerAndMicFromContributor } from "helpers/securities"
import { computeColumnLabel, computeFileName, getColumnValue } from "helpers/assets"
import { getSelectedView } from "selectors/assets"
import { getColumns } from "./columns"

const FILE_PARAMS = { dataType: "Assets" }
const EMPTY_ARRAY = []

export const getDownloadButtonTooltip = createSelector(
  [getGrouping, getSelectedGroupName],
  (grouping, selectedGroupName) => {
    if (selectedGroupName) {
      return "Download Group Contributors"
    }
    if (grouping) {
      return "Download Groups"
    }
    return "Download Contributors"
  },
)

const getFileName = createSelector(
  [getAssetName, getGrouping, getSelectedGroupName, getViewType, getEndDate, getSelectedView, getSelectedMetricType, getSelectedSubView, getMetricTypeOptions, () => FILE_PARAMS],
  computeFileName,
)

export const getDownloadData = createSelector(
  [getOrderedSecurities, getFileName, getGrouping, getSelectedGroupName, getColumns, getIsActive, getSelectedView],
  (securities, fileName, grouping, selectedGroupName, columns, isActive, selectedView) => {
    const shouldIncludeSecurityMetadata = !grouping || (grouping && selectedGroupName)
    const groupingLabel = get(grouping, "label", "")

    const cols = [
      (!shouldIncludeSecurityMetadata && groupingLabel) || "Identifier",
      ...(shouldIncludeSecurityMetadata ? ["MIC", "Bloomberg Ticker", "Country", "Asset Class", "Currency", "Industry"] : []),
      ...map(columns, column => computeColumnLabel(column, selectedView, isActive)),
      ...(selectedGroupName ? ["Selected Group"] : []),
    ]

    return {
      fileName,
      type: FILE_PARAMS.dataType,
      data: !size(securities) ? EMPTY_ARRAY : [
        cols,
        ...map(securities, security => {
          const { mic: exchange } = getTickerAndMicFromContributor(security)
          const { ticker, name, description, id, label, bloombergTicker, country, assetClass, currency, classification } = security
          return [
            ticker || name || description || id || label,
            ...(shouldIncludeSecurityMetadata ? [exchange, bloombergTicker, country, assetClass, currency, get(classification, "name")] : []),
            ...map(columns, column => getExcelValue(getColumnValue(security, column), { percent: column.outputFormat === "percent" })),
            ...(selectedGroupName ? [selectedGroupName] : []),
          ]
        }),
      ],
    }
  },
)
